<div *ngIf="show.stepper">
  <nsc-card class="mat-typography" >
    <nsc-card-content class="nsc-card-content--tight">
      <div class="nsc-stepper">
        <div class="row align-items-center" role="navigation">
          <div class="col-md" [class.col]="content.step1Selected" [class.col-auto]="!content.step1Selected">
            <div class="row align-items-center"  tabindex="0"  aria-label="step 1  of 3. Enter Personal Information ">
              <div class="col-auto">
                <div class="nsc-stepper__icon">
                  <strong class="icon">1</strong>
                </div>
              </div>
              <div class="col d-md-block" [class.d-none]="!content.step1Selected">
                <div class="mat-caption">Enter Personal Information</div>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="nsc-stepper__indicator {{ content.line1Class }}"></div>
          </div>
          <div class="col-md" [class.col]="content.step2Selected" [class.col-auto]="!content.step2Selected">
            <div class="row align-items-center" tabindex="0" aria-label="step 2 of 3. Select Transcript and Delivery Details">
              <div class="col-auto">
                <div class="nsc-stepper__icon">
                  <strong class="icon">2</strong>
                </div>
              </div>
              <div class="col d-md-block" [class.d-none]="!content.step2Selected">
                <div class="mat-caption">Select Transcript and Delivery Details</div>
              </div>
            </div>
          </div>
          <div class="col-auto">
            <div class="nsc-stepper__indicator {{ content.line2Class }}"></div>
          </div>
          <div class="col-md" [class.col]="content.step3Selected" [class.col-auto]="!content.step3Selected">
            <div class="row align-items-center" tabindex="0" aria-label="step 3 of 3. Confirm Order and Checkout">
              <div class="col-auto">
                <div class="nsc-stepper__icon">
                  <strong class="icon">3</strong>
                </div>
              </div>
              <div class="col d-md-block" [class.d-none]="!content.step3Selected">
                <div class="mat-caption">Confirm Order and Checkout</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nsc-card-content>
  </nsc-card>
</div>
